import type { RootState } from '@core';
import { createSelector } from '@reduxjs/toolkit';

/**
 * Получение значения промокода
 */
export const getPromoCodeValue = createSelector(
  (state: RootState) => state.checkout.promoCode,
  promoCode => promoCode.value
);

/**
 * Получение статуса валидации промокода
 */
export const getPromoCodeValidationStatus = createSelector(
  (state: RootState) => state.checkout.promoCode,
  promoCode => ({
    isValid: promoCode.isValid,
    isLoading: promoCode.isLoading,
    error: promoCode.error,
  })
);

/**
 * Получение ID заказа
 */
export const getOrderId = createSelector(
  (state: RootState) => state.checkout.order,
  order => order.orderId
);

/**
 * Получение URL для оплаты
 */
export const getPaymentUrl = createSelector(
  (state: RootState) => state.checkout.order,
  order => order.paymentUrl
);

/**
 * Получение статуса загрузки заказа
 */
export const getOrderLoadingStatus = createSelector(
  (state: RootState) => state.checkout.order,
  order => ({
    isLoading: order.isLoading,
    error: order.error,
  })
);

/**
 * Получение полной информации о заказе
 */
export const getOrderInfo = createSelector(
  (state: RootState) => state.checkout.order,
  order => order
);

/**
 * Получение даты и времени окончания бронирования
 */
export const getValidDateTime = createSelector(
  (state: RootState) => state.checkout.order,
  order => order.validDateTime
);
